import BaseSignUpMachineWrapperV2 from 'domains/signupv2/Wrapper/baseComponent';
import { withSignupProviderV2 } from 'domains/signupv2/Wrapper/context';

export default withSignupProviderV2(BaseSignUpMachineWrapperV2);
